import React, { createContext, useCallback, useContext, useState } from "react";

interface DevModeContextValue {
  isDevMode: boolean;
  activateDevMode: () => void;
  deactivateDevMode: () => void;
}

const DevModeContext = createContext<DevModeContextValue | null>(null);

const DEV_MODE_STORAGE_KEY = "coupleup-dev-mode";

export function DevModeProvider({ children }: { children: React.ReactNode }) {
  const [isDevMode, setIsDevMode] = useState<boolean>(() => {
    // Lade aus localStorage
    const saved = localStorage.getItem(DEV_MODE_STORAGE_KEY);
    return saved === "true";
  });

  const activateDevMode = useCallback(() => {
    setIsDevMode(true);
    localStorage.setItem(DEV_MODE_STORAGE_KEY, "true");
  }, []);

  const deactivateDevMode = useCallback(() => {
    setIsDevMode(false);
    localStorage.removeItem(DEV_MODE_STORAGE_KEY);
  }, []);

  return (
    <DevModeContext.Provider
      value={{ isDevMode, activateDevMode, deactivateDevMode }}
    >
      {children}
    </DevModeContext.Provider>
  );
}

export function useDevMode() {
  const context = useContext(DevModeContext);
  if (!context) {
    throw new Error("useDevMode must be used within DevModeProvider");
  }
  return context;
}
